<template>

    <inncosys-select :data-set-ready="storesDataSetReady" v-model="selectedStore" label="Sucursal" first-option-message="Selecciona una sucursal">
        <option value="all">Global</option>
        <option v-for="store in stores" v-bind:key="store.id" :value="store.name">
            {{store.name}}
        </option>
    </inncosys-select>
</template>

<script>

import Select from './forms/Select.vue';
import {restService} from '../../controllers/rest.js';

export default {
  components: {
    inncosysSelect: Select,
  },
  props: {
    value: String,
  },
  data() {
    return {
      stores: [],
      storesDataSetReady: false,
      selectedStore: '',
    };
  },
  watch: {
    selectedStore(value) {
      console.log(`about to emit input selected store${value}`);
      this.$emit('input', value);
      this.$emit('touch');
    },
    value(value) {
      if (value == null || value.length === 0) {
        this.pickerInstance.el.selectedIndex = 0;
        this.pickerInstance.el.selectedValue = '';
        this.selectedStore = '';
      }
    },
    vclass(value) {
      console.log(value);
      if (this.pickerInstance) {
        if (value.valid) {
          this.pickerInstance.input.classList.add('valid');
          this.pickerInstance.input.classList.remove('invalid');
        } else {
          this.pickerInstance.input.classList.add('invalid');
          this.pickerInstance.input.classList.remove('valid');
        }
      }
    },
  },
  methods: {
    getStores() {
      this.restService
        .getStores()
        .then((stores) => {
          this.stores = stores;
          this.storesDataSetReady = true;
        })
        .catch((error) => {
          console.log('ERROR WHILE GETTING SUCURSALES', error);
        });
    },
  },
  created() {
    this.restService = new restService();
    console.log('on created sucursales');
    this.getStores();
  },
};
</script>

<style scoped>
</style>
